export default __webpack_public_path__ + "img/user.4a000e6c.svg";